import { withTheme } from "@mui/material";
import { red } from "@mui/material/colors";
import { defaultTheme } from "react-admin";

const appTheme = {
    ...defaultTheme,
    body:{
        margin: 0,
    },
    palette: {
        mode: 'dark',
        primary: {
            main: "#ffffff",
        },
        secondary: {
            main: "#ffffff",
        },
        error: {
            main: '#EC8C4F',
        },
        info: {
            main: '#ffffff'
        }
    },
    typography:{
        fontFamily: ['Helvetica', 'Arial', 'Segoe UI', 'Roboto'].join(','),
        color: '#ffffff'
    },
};

appTheme.typography.body = {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '.8rem',
}
appTheme.typography.label = {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    color: 'rgba(0, 0, 0, 0.6)',
    fontSize: '1rem',
}
export default appTheme;
